import { toQuery } from 'src/shared/api/crudApi';
import { httpClient } from 'src/shared/api/httpClient';
import { API_PREFIX } from 'src/shared/constants';
import type {
  Payment,
  PaymentListParams,
  PaymentPatchPayload,
  PaymentPayload,
  RefundPayload,
} from './types';

const base = `${API_PREFIX}/payments`;

/**
 * Hand-written rather than built on `createCrudApi`: a payment is created under
 * the appointment it settles, corrected through a refund of its own, and never
 * updated or deleted. Only the listing has the shape the factory generates.
 */
export const paymentsApi = {
  /** Every movement on one appointment, unpaginated — there are only ever a few. */
  listForAppointment: (appointmentId: number) =>
    httpClient.get<Payment[]>(`${API_PREFIX}/appointments/${appointmentId}/payments`),

  /** The till. Behind `finance:read`, so staff gets a 403 here by design. */
  list: (params: PaymentListParams = {}) => httpClient.list<Payment>(`${base}/?${toQuery(params)}`),

  record: (appointmentId: number, data: PaymentPayload) =>
    httpClient.post<Payment>(`${API_PREFIX}/appointments/${appointmentId}/payments`, data),

  refund: (paymentId: number, data: RefundPayload) =>
    httpClient.post<Payment>(`${base}/${paymentId}/refunds`, data),

  patch: (paymentId: number, data: PaymentPatchPayload) =>
    httpClient.patch<Payment>(`${base}/${paymentId}`, data),
};
